<template>
    <component
        :is="tag"
        :class="{ iconButton: true, primary, noText, small, active, success, danger }"
        :disabled="disabled"
        @click="onClick"
    >
        <i v-if="icon" :class="['faIcon', 'fa', icon]"></i>
        <slot v-if="!noText"></slot>
    </component>
</template>

<script>
export default {
    name: 'IconButton',

    props: {
        icon: {
            type: String,
            default: null
        },
        primary: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        noText: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        success: {
            type: Boolean,
            default: false
        },
        danger: {
            type: Boolean,
            default: false
        },
        tag: {
            type: String,
            default: 'button'
        }
    },

    methods: {
        onClick(e) {
            this.$emit('click', e);
        }
    }
};
</script>

<style lang="scss">
@import '../../assets/styles/components/button';

.iconButton {
    @include button();

    &:not(.noText) .faIcon {
        margin-right: 2px;
    }

    &.small {
        padding: 1px 5px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
    }
}
</style>
